export default {
    route: {
        Dashboard: 'Home Page',
        Setting: 'Configuration Center',
        Business: 'Business Center',
        SettingUser: 'User Management',
        SettingUserOrganization: 'Organizational Structure',
        SettingUserAccount: 'Account Security Policy',
        SettingGoods: 'Products Management',
        SettingGoodsAudit: 'Product Review Policy', // '商品审核策略',
        SettingStock: 'Inventory Management',
        SettingStockStructure: 'Warehouse Structure Configuration',
        SettingStockRatio: 'Warehouse Ratio Configuration',
        SettingStockAudit: 'Warehouse Review Policy',
        SettingStockRules: 'Inventory Rules',
        SettingLogistics: 'Logistics Management',
        SettingLogisticsStrategy: 'Logistics Policy',
        SettingLogisticsStrategyAuthorize: 'Logistics Authorization',
        SettingOrder: 'Order Management',
        SettingOrderSourceStrategy: 'Sourcing Strategy',
        SettingOrderSourceDeploy: 'Sourcing Configuration',
        SettingFinance: 'Finance Management',
        SettingFinanceStatement: 'Reconciliation Basic Configuration',
        SettingFinanceAnalysis: 'Platform Bill Parsing Strategy',
        SettingBaseData: 'Basic Data',
        SettingBaseDataConfig: 'System Application',
        SettingBaseDataCodeRule: 'Coding Rules',
        SettingBaseDataCountry: 'Country Definition',
        SettingBaseDataRegion: 'Administrative Region Definition',
        SettingBaseDataAfterSalesReason: 'After-sale Reason',
        SettingBaseDataLov: 'Value Set',
        SettingIndexes: 'Index Configuration',
        SettingIndexesConfig: 'Index Configuration List',
        SettingInquiry: 'Query Configuration',
        SettingIndexesSync: 'Index Synchronization',
        SettingFile: 'File',
        SettingFileSearch: 'Summary Query',
        SettingFileStorage: 'Storage Configuration',
        SettingFileUploadRam: 'Upload Capacity Configuration',
        SettingFileUploadConfig: 'Upload Details Configuration',
        SettingInstance: 'Transaction',
        SettingInstanceManage: 'Transaction List',
        SettingWorkflow: 'Workflow',
        SettingWorkflowBpmn: 'Workflow Design',
        SettingTenant: 'Tenant Management',
        SettingTenantManage: 'Tenant',
        SettingTenantManageIndex: 'tenant',
        SettingTenantManageAdd: 'Add Tenant',
        SettingTenantManageEdit: 'Edit Tenant',
        SettingBaseDataRefreshService: 'Refresh Service',
        SettingBaseDataRefreshServiceIndex: 'Refresh Service',
        SettingBaseDataExchangeRate: 'Exchange Rate Maintenance',
        BusinessUser: 'User',
        BusinessUserAccount: 'Account',
        BusinessUserAccountCSG: 'Account',
        BusinessUserRole: 'Role',
        BusinessUserRoleAdminCSG: 'Role',
        BusinessUserCustomerCSG: 'Account',
        BusinessChannel: 'Channel',
        BusinessPlatForm: 'Channel',
        BusinessInbound: 'Inbound',
        BusinessChannelOnline: 'Channel',
        BusinessChannelOnlineCsg: 'Store',
        BusinessChannelOnlineCsgAdmin: 'Store',
        BusinessChannelExternalPlatformOrders: 'External Platform Orders',
        BusinessChannelEDIOrders: 'EDI Tools',
        BusinessChannelPhysical: 'Physical Store',
        BusinessChannelStorage: 'Warehouse',
        BusinessGoods: 'Product',
        BusinessGoodsSpu: 'SPU',
        BusinessGoodsSku: 'SKU',
        CSGGoodsSku: 'Product',
        BusinessGoodsClassify: 'Category',
        BusinessGoodsBrand: 'Brand',
        BusinessGoodsMaterial: 'Material',
        BusinessGoodsPriceItem: 'Price Item',
        BusinessGoodsAudit: 'Product Review',
        BusinessGoodsAuditCSG: 'Product Review',
        BusinessStock: 'Inventory',
        BusinessStockSearch: 'Inventory',
        BusinessStockSearchCSG: 'Inventory',
        BusinessStockUserCsg: 'Customer Pallet',
        BusinessBatchInventoryQuery: 'Batch inventory',
        BusinessBatchShipmentecord: 'Batch inventory shipment records',
        BusinessStorageTransactionReport: 'Storage Record',
        BusinessStockChange: 'Inventory Transaction',
        BusinessStockMovement: 'Stock Movement',
        BusinessStockChangeCSG: 'Inventory Transaction',
        BusinessStockEntry: 'Inbound',
        BusinessStockDelivery: 'Outbound',
        BusinessStockConsign: 'Printing And Shipping',
        BusinessStockTransfer: 'Allocation',
        BusinessStockLock: 'Inventory Reservation',
        BusinessStockVerify: 'Inventory Change Review',
        BusinessStockDistribution: 'Product Allocation',
        BusinessStockSynchronization: 'Data Synchronization',
        BusinessLogistics: 'Logistics',
        BusinessLogisticsCompany: 'Logistics Provider',
        BusinessLogisticsCompanyCSGUser: 'Courier',
        BusinessLogisticsCompanyCSGAdmin: 'Courier',
        BusinessOrder: 'Outbound',
        BusinessOrderInternal: 'Processing Order', // '内部销售单',
        BusinessOrderInternalCSGAdmin: 'Closed Orders', // '内部销售单',
        BusinessOrderInternalCSGFEE: 'Fee Information', // '费用信息',
        BusinessOrderInternalCSGUser: 'Processing Order', // '内部销售单',
        BusinessOrderInternalErrorCSGAdmin: 'Error Order', // '内部销售单',
        BusinessOrderAudit: 'Pending Review Sales Order',
        BusinessOrderPreempt: 'Reservation',
        BusinessOrderSource: 'Sourcing',
        BusinessOrderShort: 'Out of Stock Order',
        BusinessOrderShortCSG: 'Out of Stock Order',
        BusinessAbnormalOrderProcessing: 'Error Order',
        BusinessETAQuery: 'ETA query',
        BusinessOrderSend: 'Order Push',
        BusinessThird: 'External',
        BusinessThirdGoods: 'External Product',
        BusinessThirdOrder: 'Sales Order', // '三方销售单',
        BusinessThirdOrderCSGAdmin: 'Sales Order', // '三方销售单',
        BusinessThirdOrderCSGUser: 'Sales Order', // '三方销售单',
        BusinessThirdO2o: 'External O2O Order',
        BusinessThirdAfter: 'External Sales Order',
        BusinessThirdMapOutStore: 'External Store Mapping',
        BusinessAfterCsgReturnIndex: 'Return Order',
        BusinessAfterCsgReturnView: 'Return Order Details',
        BusinessAfterCsgReturnAdd: 'New Return Order',
        BusinessAfterCsgReturnEdit: 'Edit Return Order',
        BusinessAfterReturnList: 'Return List',
        BusinessOpenReturnList: 'Open Return List',
        BusinessCloseReturnList: 'Close Return List',
        BusinessAfterReturnView: 'Return Detail',
        BusinessAfterReturnConfim: 'Warehouse Personnel Confirmation',
        BusinessAfterReturnAdd: 'Add Return',
        BusinessAfterReturnEdit: 'Edit Return',
        BusinessAfterCsgAdminReturnIndex: 'Return Order',
        BusinessAfterCsgAdminReturnView: 'Return Order Details',
        BusinessAfterCsgAdminReturnAdd: 'New Return Order',
        BusinessAfterCsgAdminReturnEdit: 'Edit Return Order',
        BusinessAfterCsgAdminReturnConfim: 'Confim Return Order',
        BusinessWorkOrderAudit: 'WorkOrder Review Button',
        BusinessO2o: 'O2O Order',
        BusinessO2oInternal: 'Internal O2O Order',
        BusinessO2oAudit: 'Pending Review O2O Order',
        BusinessAfter: 'Return',
        BusinessAfterInternal: 'Internal After-sales Order',
        BusinessAfterAudit: 'Pending Review After-sales Order',
        BusinessFinance: 'Financial',
        BusinessFinancePlatformOriginal: 'Platform Bill (Original)',
        BusinessFinancePlatform: 'Platform Bill',
        BusinessFinanceChecking: 'Platform Reconciliation',
        BusinessLabel: 'Label',
        BusinessLabelSys: 'System Label',
        BusinessLabelHand: 'Manual Label',
        BusinessMarketing: 'Marketing',
        BusinessMarketingActivity: 'Gift',
        BusinessMarketingGift: 'Accompanying Product Rule',
        BusinessReport: 'Report',
        BusinessBIReport: 'BI Report',
        BusinessBIReportIndex: 'CSG Profit Analysis Report',
        BusinessBIReportCSGProfitAnalysisReport: 'Profit Analysis',
        BusinessBIReportTicketCompletionPerformanceReport: 'Profit Analysis - Net',
        BusinessBIReportWarehousePerformanceReport: 'Ticket Performance',
        BusinessBIReportProfitAnalysisReport: 'Warehouse Performance',
        BusinessBIReportNewCompletionPerformanceReport: 'New Profit Analysis - Net',
        BusinessSalesDaily: 'BI Sales Report',
        BusinessSalesDailyIndex: 'Sales Daily',
        BusinessSalesDailyWeekSalesReport: 'Sales Weekly Profit Analysis Report',
        BusinessSalesDailyMonthlyAnalysisReport: 'Sales Monthly Analysis Report',
        BusinessSalesDailySelloProfitMetricMonitor: 'Sello Profit Metric Monitor',
        BusinessSalesDailyWarehouseBIReport: 'Warehouse BI Report',
        BusinessSalesDailySkuPurchaseAnalysisReport: 'Sku Purchase Analysis Report',
        BusinessSalesDailyLossOrderAnalysis: 'Loss Order Analysis',
        BusinessSalesDailySalesAnalysis: 'SalesAnalysis By Shipping Zone',
        BusinessSalesDailyDetailDown: 'Sello Data Details Download',
        BusinessInventoryReport: 'Class A product Closing Inventory',
        BusinessReportSale: 'Order Report',
        BusinessReportSaleCSG: 'Order Report',
        BusinessReportStock: 'Inventory',
        BusinessReportOrder: 'Order',
        BusinessReportOrderIndex: 'Order Statistics Table',
        BusinessOrderTimeliness: 'Order Timeliness',
        BusinessOrderTimelinessAverage: 'Average processing time table',
        BusinessOrderTimelinessOnTime: 'On-time processing percentage table',
        BusinessOrderWarehouseEfficiency: 'Warehouse Efficiency',
        BusinessOrderWarehousePickerRank: 'Picker Rank',
        BusinessOrderrWarehouseForkliftDriver: 'Forklift Driver Rank',
        BusinessImport: 'Import',
        BusinessImportHistory: 'Import History',
        BusinessImportGeneral: 'General Import',
        BusinessPurchase: 'Purchasing',
        BusinessQuotation: 'Quotation',
        BusinessPayment: 'Payment Term',
        BusinessPaymentProcessingIndex: 'Payment Term Processing',
        BusinessPaymentStatisticsIndex: 'Payment Term Statistics',
        BusinessBilling: 'Billing',
        BusinessBillingPrice: 'Rate Card',
        BusinessBillingServiceInvoices: 'My Invoice',
        BusinessBillingCategories: 'Charge Item',
        BusinessBillingProfileTemplates: 'Client Template',
        BusinessBillingClientProfiles: 'Customer Profile',
        BusinessBillingTransactions: 'Transactions',
        BusinessBillingDeposit: 'Prepay',
        BusinessBillingMyDeposit: 'My Wallet',
        BusinessBillingDeposiInfo: 'Prepay Info',
        BusinessBillingClientAccounts: 'Client Accounts',
        BusinessBillingCustomerInventoryPricing: 'Inventory Value',
        BusinessBillingCostExpenditureStatistics: 'Expense Management',
        BusinessBillingCostItem: 'Cost Item',
        BusinessBillingPreviewInvoices: 'Preview Invoice',
        BusinessBillingInvoiceReview: 'Invoice Review',
        BusinessBillingInvoices: 'Invoice',
        BusinessBillingAdditionalCharge: 'Manual Charge',
        BusinessBillingCredit: 'Credit Note',
        BusinessBillingExpense: 'Expense Management',
        BusinessBillingHistorical: 'Charge Item Cost',
        BusinessBillingHistoricaCost: 'Cost History',
        BusinessBillingRegularSurcharge: 'Regular Surcharge',
        BusinessBillingInvoiceStatement: 'Invoice Statement',
        BusinessBillingPostageRecharge: 'Postage Charges',
        BusinessBillingPostageRechargeDetail: 'Postage Charges Detail',
        BusinessBillingShippingCharges: 'Shipping Comparison',
        BusinessBillingStorageReport: 'Storage Report',
        BusinessBillingDeliveryNote: 'Delivery Note',
        BusinessBillingServiceItem: 'Service Item',
        BusinessBillingAddDeliveryNote: 'Add Delivery Note',
        BusinessBillingInvoiceReport: 'Invoice Report',
        BusinessBillingTierSetting: 'Tier Setting',
        BusinessBillingOperationLog: 'Operation Log',
        BusinessBillingPostage: 'Postage Comparison',
        BusinessOrderPostagDetail: 'Details Of Postage Comparison',
        WMSPage: 'WMS',
        WMSWavePage: 'Wave List',
        WMSWaveDetail: 'Wave Detail',
        WMSSortingStation: 'Sorting Station',
        WMSNSTD: 'NSTD',
        WMSLampRack: 'LED Rack Config',
        customerMenu: 'Customer',
        onboardingDashboard: 'Dashboard',
        onboardingPageIndex: 'Onboarding',
        BusinessHelp: 'Help',
        BusinessHelpManual: 'User Manual',
        BusinessPurchaseSupplier: 'Supplier',
        BusinessPurchaseSupplierShop: 'Supplier products',
        BusinessPurchaseForecast: 'Purchase Forecast',
        BusinessInventoryPrediction: 'Inventory Forecast Report',
        BusinessPurchaseApply: 'Purchase Order',
        BusinessPurchaseOrder: 'Purchase Cabinet List',
        BusinessPurchaseOrderCsgAdminclosedIndex: 'Closed Receipt',
        BusinessPurchaseOrderCsgAdminIndex: 'Open Receipt',
        BusinessPurchaseOrderTimeConfigure: 'Receipt Time Configuration',
        BusinessPurchaseTemporaryNot: 'Open Temporary Storage',
        BusinessPurchaseTemporaryYet: 'Closed Temporary Storage',
        BusinessPurchaseDetailCsg: 'Inbound Order Detail',
        BusinessPurchaseEntry: 'Purchase Inbound List',
        BusinessPurchaseGetLow: 'Statistical SKU Cost Reduction',
        BusinessPurchaseTimeliness: 'Timeliness Rate Of Return Orders',
        BusinessPurchaseReturn: 'Purchase Order return',
        SettingUserOrganizationGroup: 'Group Settings',
        BusinessQuotationBasics: 'Basic Configuration',
        BusinessPurchaseBasics: 'Basic Configuration',
        BusinessQuotationHistory: 'Historical Data',
        BusinessQuotationQuoteIndex: 'Quotation',
        BusinessQuotationQuoteDetail: 'Quotation Details',
        BusinessQuotationQuoteAdd: 'Add Quotation',
        BusinessQuotationQuoteEdit: 'Edit Quotation',
        SettingUserOrganizationCompany: 'Subsidiaries',
        SettingUserAccountStrategy: 'Account Security Policy Configuration',
        SettingStockRatioConfig: 'Inventory Ratio Configuration',
        SettingStockAuditStrategy: 'Inventory Review Policy',
        SettingStockRulesConfig: 'Inventory Rules',
        SettingLogisticsStrategyConfig: 'Logistics Policy',
        SettingOrderSourceStrategySourcing: 'Sourcing Strategy',
        SettingOrderSourceStrategyParcel: 'Parcel Rules',
        SettingOrderSourceDeployConfig: 'Sourcing configuration',
        SettingBaseDataConfigIndex: 'System Application',
        SettingBaseDataCodeRuleIndex: 'Coding Rules',
        SettingBaseDataAfterSalesReasonRefundIndex: 'Refund Reason',
        SettingBaseDataAfterSalesReasonReturnIndex: 'Return Refund Reason',
        SettingBaseDataLovHeaderIndex: 'Value Set Header',
        SettingFileUploadConfigIndex: 'Upload Details Configuration',
        BusinessUserRoleIndex: 'Role',
        BusinessChannelOnlineIndex: 'Channel',
        BusinessChannelOnlineTripartite: 'Tripartite Platform',
        BusinessChannelOnlineFlowDistribution: 'Allocate Logistics',
        BusinessChannelOnlineFlowDistributionCsg: 'Allocate Logistics',
        BusinessChannelOnlineFlowDistributionCsgAdmin: 'Allocate Logistics',
        BusinessChannelOnlinePric: 'Online Store Product Price',
        BusinessChannelPhysicalIndex: 'Physical Store',
        BusinessChannelStorageIndex: 'Warehouse',
        BusinessGoodsSpuOrdinaryIndex: 'Common Product',
        BusinessGoodsSpuPackageIndex: 'Package Product',
        BusinessGoodsSkuOrdinaryIndex: 'SKU List',
        CSGGoodsSkuOrdinaryIndex: 'SKU List',
        BusinessGoodsSkuPackageIndex: 'Sales Kit List',
        CSGGoodsSkuPackageIndex: 'Sales Kit List',
        BusinessGoodsSkuDraftIndex: 'Draft SKU List',
        BusinessGoodsPackageManagement: 'Package Management',
        BusinessGoodsClassifyIndex: 'Category',
        BusinessGoodsBrandIndex: 'Brand',
        BusinessGoodsMaterialIndex: 'Material',
        BusinessGoodsPriceItemIndex: 'Price Item',
        BusinessGoodsAuditSkuOrdinaryIndex: 'SKU Review',
        BusinessGoodsAuditSkuOrdinaryCSGIndex: 'SKU Review',
        BusinessGoodsAuditSkuPackageIndex: 'Sales Kit Review',
        BusinessGoodsAuditSkuPackageCSGIndex: 'Sales Kit Review',
        BusinessStockSearchIndex: 'Inventory',
        BusinessStockChangeIndex: 'Inventory Transaction',
        BusinessStockEntryInformIndex: 'Inbound Notification',
        BusinessStockEntryResultIndex: 'Inbound Result',
        BusinessStockDeliveryInformIndex: 'Outbound Notification',
        BusinessStockDeliveryResultIndex: 'Outbound Result',
        BusinessStockConsignIntimidate: 'Printing and Shipping',
        BusinessStockConsignCheck: 'Inspection and Shipping',
        BusinessStockTransferVirtualIndex: 'Virtual Warehouse Transfer',
        BusinessStockLockIndex: 'Inventory Reservation',
        BusinessStockVerifyVirtualIndex: 'Virtual Warehouse Transfer Review',
        BusinessStockVerifyLockIndex: 'Inventory Reservation Review',
        BusinessStockVerifyPlanIndex: 'Warehouse Allocation Plan Review',
        BusinessStockDistributionQtyIndex: 'Bin Quantity Allocation',
        BusinessStockDistributionRatioIndex: 'Bin Ratio Allocation',
        BusinessStockDistributionPlanIndex: 'Warehouse Allocation Plan',
        BusinessStockSynchronizationIndex: 'Data Synchronization',
        BusinessStockInventoryWarning: 'Inventory Alert',
        BusinessAbnormalOrderIndex: 'Open Orders',
        BusinessAbnormalOrderTIMEOUT: 'Pre-authorization timeout',
        BusinessAbnormalOrderANOMALY: 'Error Orders',
        BusinessAbnormalOrderSTOCK: 'New Orders',
        BusinessAbnormalOrderOUTOFSTOCK: 'Out-of-Stock Orders',
        BusinessAbnormalOrderWAIRING: 'Waiting to be shipped',
        BusinessAbnormalOrderCOLLECTPENDING: 'Ready for Collection',
        BusinessAbnormalOrderCOLLECTPENDINGLabel: 'Label Uploaded',
        BusinessAbnormalOrderEXCEPTION: 'Push Timeout',
        BusinessAbnormalOrderPROCESSINGOrder: 'Processing Orders',
        BusinessSystemOnlineNotification: 'Go-Live Notification',
        BusinessSystemOnlineNotificationDetailAdd: 'Add Notification',
        BusinessSystemOnlineNotificationDetailEdit: 'Edit Notification',
        BusinessAbnormalOrderALL: 'ALL',
        BusinessAbnormalOrderPendingHJCancel: 'Pending HJ Cancel',
        BusinessAbnormalOrderUrgent: 'Urgent',
        BusinessAbnormalOrderHUNT: 'Pending Manual Cancel',
        BillingPageInvoiceReportTotal: 'Total',
        BillingPageInvoiceReportPallet: 'Pallet',
        BillingPageInvoiceReportCBM: 'CBM',
        BillingPageInvoiceReportClientQty: 'Client Qty',
        BillingPageInvoiceReportClient: 'Client',
        BillingPageInvoiceReportPostage: 'Postage',
        BillingPageInvoiceReportSales: 'Sales',
        BusinessLogisticsCompanyListIndex: 'Logistics Provider',
        BusinessLogisticsCompanyListIndexCSGUser: 'Logistics Provider',
        BusinessLogisticsCompanyListIndexCSGAdmin: 'Logistics Provider',
        BusinessLogisticsCompanyBusinessIndex: 'Logistics Service',
        BusinessLogisticsCompanyBusinessIndexCSGUser: 'Logistics Service',
        BusinessLogisticsCompanyBusinessIndexCSGAdmin: 'Logistics Service',
        BusinessLogisticsCompanyBusinessSetting: 'Delivery Channel Settings',
        BusinessLogisticsImport: 'Logistics Information Import',
        BusinessLogisticsRate: 'Logistics Rate',
        BusinessLogisticsRateIndex: 'Logistics Rate',
        BusinessLogisticsRateAdd: 'Add Logistics Rates',
        BusinessLogisticsRateView: 'Logistics Rate Details',
        BusinessLogisticsNewRate: 'Logistics Rate',
        BusinessLogisticsNewRateIndex: 'Logistics Rate',
        BusinessLogisticsZone: 'Zone Group',
        BusinessLogisticsZoneIndex: 'Zone Group',
        BusinessLogisticsZoneDetail: 'Zone Detail',
        BusinessLogisticsZoneImportFile: 'Zone Data Import',
        BusinessLogisticsProduct: 'Logistics Products',
        BusinessLogisticsProductSetting: 'Product Settings',
        BusinessLogisticsCompanyPostCodeIndex: 'Postcode',
        BusinessLogisticsCompanyPostCodeIndexCSGUser: 'Postcode',
        BusinessLogisticsCompanyPostCodeIndexCSGAdmin: 'Postcode',
        BusinessLogisticsCompanyManagementIndexCSGAdmin: 'Customer Logistics',
        BusinessLogisticsCompanIndexCSGAdmin: 'Customer logistics management',
        BusinessLogisticsCompanyRelationIndex: 'Freight Association Settings',
        BusinessLogisticsCompanyFreightIndex: 'Freight Template',
        BusinessLogisticsCompanyMapping: 'Logistics Mapping',
        BusinessOrderInternalIndex: 'Internal Sales Order',
        BusinessOrderAuditIndex: 'Pending Review Sales Order',
        BusinessOrderBookLogistic: 'Book Logistic',
        BusinessOrderPreemptIndex: 'Reservation',
        BusinessOrderSourceIndex: 'Sourcing',
        BusinessOrderShortIndex: 'Order Out-of-Stock',
        BusinessThirdGoodsIndex: 'External Platform Products',
        BusinessThirdOrderIndex: 'External Sales Order',
        BusinessThirdO2oIndex: 'External O2O Order',
        BusinessThirdAfterIndex: 'External After-Sales Order',
        BusinessThirdStoreMappingIndex: 'External Store Mapping',
        BusinessO2oInternalIndex: 'Internal O2O Order',
        BusinessO2oAuditIndex: 'Pending Review O2O Order',
        BusinessAfterInternalRefundIndex: 'Internal Refund Only',
        BusinessAfterInternalReturnIndex: 'Internal Return and Refund',
        BusinessAfterInternalReship: 'Resend',
        BusinessAfterAuditRefundIndex: 'Refund Only Pending Review',
        BusinessAfterAuditReturnIndex: 'Return and Refund Pending Review',
        BusinessFinancePlatformOriginalTmallIndex: 'Tmall bill',
        BusinessFinancePlatformOriginalJdcomIndex: 'JD Bill',
        BusinessFinancePlatformListIndex: 'Platform bill',
        BusinessFinanceCheckingDoneIndex: 'Reconciled Bill List',
        BusinessFinanceCheckingActionIndex: 'Bill Reconciliation Processing',
        BusinessLabelSysIndex: 'System Label',
        BusinessLabelHandIndex: 'Manual Label',
        BusinessMarketingActivityIndex: 'Gift Activity List',
        BusinessMarketingGiftIndex: 'Accompanying Product Rule List',
        BusinessReportSaleCensusIndex: 'Sales Statistics Table',
        BusinessReportSaleCensusIndexCSG: 'Sales Statistics Table',
        BusinessReportSaleAnalysisIndex: 'Sales Analysis Table',
        BusinessReportSaleGoodsIndex: 'Sales Product Statistics Table',
        BusinessReportSaleShopIndex: 'Store Sales Table',
        BusinessReportStockDeliverIndex: 'Shipment Summary Table',
        BusinessReportStockOutIndex: 'Out-of-Stock Statistics Table',
        BusinessImportHistoryIndex: 'Import History List',
        BusinessImportGeneralIndex: 'Generic Import List',
        BusinessPurchaseSupplierIndex: 'Supplier',
        BusinessPurchaseSupplierShopIndex: 'Supplier Product',
        BusinessPurchaseApplyIndex: 'Purchase Requisition',
        BusinessPurchaseOrderIndex: 'Purchase Order',
        BusinessPurchaseEntryInform: 'Purchase Inbound Notification',
        BusinessPurchaseEntryResult: 'Purchase Inbound Result',
        BusinessPurchaseReturnInform: 'Purchase Return Outbound Notification',
        BusinessPurchaseReturnResult: 'Purchase Return Outbound Result',
        SettingLogisticsStrategyOrderMoneyIndex: 'Set Order Amount',
        SettingLogisticsStrategyZonesIndex: 'Set Province/City/Area',
        SettingLogisticsStrategyWarehouseIndex: 'Set Warehouse',
        SettingLogisticsStrategyAssignGoodsIndex: 'Set Specified Product',
        SettingBaseDataCodeRuleEdit: 'Coding Rules - Edit',
        SettingWorkflowBpmnAdd: 'Add workflow',
        SettingWorkflowBpmnEdit: 'Edit Workflow',
        BusinessUserAccountAdd: 'Create Account',
        BusinessUserAccountAddCSG: 'Create Account',
        BusinessUserAccountEdit: 'Edit Account',
        BusinessUserAccountEditCSG: 'Edit Account',
        BusinessUserAccountCustom: 'Create Customer',
        BusinessUserCustomerAddCSG: 'Create Customer',
        BusinessUserCustomerEditCSG: 'Edit Customer',
        BusinessUserCustomerOffline: 'Customer Offline',
        BusinessUserAccountOffline: 'Account Offline',
        BusinessStorageExportCBM: 'Storage Export CBM',
        BusinessUserDepartment: 'Department Management',
        BusinessUserDepartmentBackup: 'Customer File',
        BusinessUserDepartmentBackupDetail: 'Customer File Detail',
        BusinessUserStaffManagement: 'Staff Management',
        BusinessUserDeptManagement: 'Dept Management',
        BusinessUserHourManagement: 'Workforce',
        QuotationCenterManagement: 'Quotation',
        BusinessQuotationSupplier: 'Supplier Quotation',
        BusinessQuotationDetails: 'Quotation Details',
        BusinessQuotationShippingCost: 'Shipping Cost',
        BusinessQuotationOtherCost: 'Other Cost',
        BusinessQuotationTrialCalculation: 'Trial Calculation',
        BusinessQuotationCustomer: 'Customer Standard Quotation',
        BusinessQuotationCustomerDetails: 'Quotation Details',
        BusinessQuotationCustomerShippingCost: 'Shipping Cost',
        BusinessQuotationCustomerOtherCost: 'Other Cost',
        BusinessQuotationCustomerTrialCalculation: 'Trial Calculation',
        BusinessQuotationVIPCustomer: 'VIP Customer Quotation',
        BusinessFuelSurchargeRate: 'Fuel Surcharge Rate Maintenance',
        BusinessUserTimeManagement: 'Timesheet Management',
        BusinessUserDepartPosition: 'Position Management',
        BusinessUserfunConfig: 'Operation Preferences',
        BusinessUserfunConfigInfo: 'Operation Preferences Detail',
        BusinessUserAccountEditCustom: 'Edit Customer',
        BusinessUserRoleAllotUser: 'Assign User',
        BusinessUserRoleAllotUserCSG: 'Assign User',
        BusinessUserRoleAllotMenu: 'Assign Menu Permissions',
        BusinessUserRoleAllotMenuCSG: 'Assign Menu Permissions',
        BusinessGoodsSpuOrdinaryAdd: 'Add Regular Product',
        BusinessGoodsSpuOrdinaryEdit: 'Edit Regular Product',
        BusinessGoodsSpuPackageAdd: 'Add Bundle Product',
        BusinessGoodsSpuPackageEdit: 'Edit Bundle Product',
        BusinessGoodsSpuPackageView: 'Bundle Product Details',
        BusinessGoodsSkuOrdinaryAdd: 'Add Regular SKU',
        CSGGoodsSkuOrdinaryAdd: 'Add Regular SKU',
        BusinessGoodsSkuOrdinaryEdit: 'Edit Regular SKU',
        CSGGoodsSkuOrdinaryEdit: 'Edit Regular SKU',
        BusinessGoodsSkuOrdinaryView: 'Regular SKU Details',
        CSGGoodsSkuOrdinaryView: 'Regular SKU Details',
        BusinessGoodsSkuPackageAdd: 'Add Bundle SKU',
        CSGGoodsSkuPackageAdd: 'Add Bundle SKU',
        BusinessGoodsSkuPackageEdit: 'Edit Bundle SKU',
        CSGGoodsSkuPackageEdit: 'Edit Bundle SKU',
        BusinessGoodsSkuPackageView: 'Bundle SKU Details',
        CSGGoodsSkuPackageView: 'Bundle SKU Details',
        BusinessGoodsAuditSkuOrdinaryView: 'View SKU Review Details',
        BusinessGoodsAuditSkuOrdinaryCSGView: 'View SKU Review Details',
        BusinessGoodsAuditSkuOrdinaryAudit: 'Review SKU Review Details',
        BusinessGoodsAuditSkuOrdinaryCSGAudit: 'Review SKU Review Details',
        BusinessGoodsAuditSkuPackageView: 'View Bundle SKU Review Details',
        BusinessGoodsAuditSkuPackageAudit: 'Review Bundle SKU Review Details',
        BusinessStockDistributionQtyAddSku: 'Warehouse Allocation by Product',
        BusinessStockDistributionQtyAddWarehouse: 'Warehouse Allocation in Bulk',
        BusinessStockDistributionQtyView: 'View Warehouse Allocation',
        BusinessStockDistributionQtyEdit: 'Edit Warehouse Allocation',
        BusinessStockSynchronizationDetail: 'Data Synchronization Details',
        BusinessLogisticsCompanyFreightEdit: 'Edit Freight Template',
        BusinessOrderInternalAdd: 'Sales Order Entry',
        BusinessOrderInternalAddCSG: 'Sales Order Entry',
        BusinessOrderInternalEditCSG: 'Sales Order Edit',
        BusinessThirdOrderView: 'External Sales Order Details',
        BusinessThirdOrderCSGView: 'External Sales Order Details',
        BusinessThirdOrderCSGViewUser: 'External Sales Order Details',
        BusinessThirdCopyOrderView: 'Resend Order',
        BusinessAddThirdOrderView: 'Add',
        BusinessAddThirdOrderCSGView: 'Add',
        BusinessAddThirdOrderCSGViewUser: 'Add',
        BusinessThirdReissueOrderView: 'Reissue Order',
        BusinessOrderInternalView: 'Internal Sales Order Details',
        BusinessOrderInternalViewCSG: 'Internal Sales Order Details',
        BusinessOrderInternalViewCSGUser: 'Internal Sales Order Details',
        BusinessOrderInternalViewLoss: 'Loss Order Details',
        BusinessAfterInternalRefundAdd: 'Create Internal Refund Order',
        BusinessAfterInternalReturnAdd: 'Create Internal Return and Refund Order',
        BusinessOrderPreemptView: 'Reservation Details',
        BusinessOrderSourceView: 'Sourcing Details',
        BusinessThirdO2oAdd: 'Create External O2O Order',
        BusinessAfterInternalRefundView: 'Internal Refund Order Details',
        BusinessThirdAfterView: 'External After-Sales Order Details',
        BusinessAfterInternalReturnView: 'Internal Return and Refund Order Details',
        BusinessImportGeneralEdit: 'Edit General Template',
        BusinessPurchaseApplyDetail: 'Purchase Requisition Details',
        BusinessPurchaseApplyIndexAdd: 'Create Purchase Requisition',
        BusinessPurchaseApplyIndexEdit: 'Edit Purchase Requisition',
        BusinessPurchaseApplyIndexCopy: 'Copy Purchase Requisition',
        BusinessPurchaseOrderCsgAdd: 'Create Inbound Order',
        BusinessPurchaseOrderCsgAdminAdd: 'Create Inbound Order',
        BusinessPurchaseOrderCsgAdminDetail: 'Create Purchase Order',
        BusinessPurchaseOrderCsgAdminReceive: 'Receiving Purchase Order',
        BusinessPurchaseOrderIndexDetail: 'Purchase Order Details',
        BusinessPurchaseDetail: 'Purchase Order Details',
        BusinessPurchaseEntryInformAdd: 'Create Purchase Inbound Notification',
        BusinessPurchaseEntryInformEdit: 'Edit Purchase Inbound Notification',
        BusinessPurchaseEntryInformDetail: 'Purchase Inbound Notification Details',
        BusinessPurchaseReturnInformAdd: 'Create Purchase Return Order',
        BusinessPurchaseReturnInformEdit: 'Edit Purchase Return Outbound Notification',
        BusinessPurchaseReturnInformDetail: 'Purchase Return Outbound Notification Details',

        SettingStockStructureView: 'Warehouse Structure Configuration Details',
        BusinessAfterInternalExchangeAdd: 'Create Internal Exchange Order',
        BusinessAfterInternalExchangeView: 'Internal Exchange Order Details',
        BusinessFinanceCheckingDoneView: 'Reconciliation Bill Detailss',
        BusinessGoodsSpouOrderyView: 'General Product Details',
        BusinessImportGeneralAdd: 'Create General Template',
        BusinessImportGeneralColumn: 'Template Columns',
        BusinessLogisticsCompanyFreightAdd: 'Create Shipping Template',
        BusinessPurchaseApplyChangePurchase: 'Convert to Purchase Order',
        BusinessPurchaseOrderCsgEdit: 'Modify Inbound Order',
        BusinessPurchaseOrderCsgAdminEdit: 'Modify Inbound Order',
        BusinessPurchaseOrderCsgAdminVerify: 'Dimension Verification',
        BusinessPurchaseEntryResultDetail: 'Purchase Inbound Result Details',
        BusinessPurchaseReturnResultDetail: 'Purchase Return Result Details',
        BusinessStockEntryInformView: 'Inbound Notification Details',
        BusinessStockEntryResultView: 'Inbound Result Details',
        BusinessStockDeliveryInformView: 'Outbound Notification Details',
        BusinessStockDeliveryResultView: 'Outbound Result Details',
        BusinessStockTransferLogicIndex: 'Logical Warehouse Transfer',
        BusinessStockTransferLogicAdd: 'Create Logical Warehouse Allocation',
        BusinessStockTransferLogicEdit: 'Edit Logical Warehouse Allocation',
        BusinessStockTransferLogicView: 'Logical Warehouse Allocation Details',
        BusinessStockTransferVirtualAdd: 'Create Virtual Warehouse Transfer',
        BusinessStockTransferVirtualEdit: 'Edit Virtual Warehouse Transfer',
        BusinessStockTransferVirtualView: 'Virtual Warehouse Transfer Details',
        BusinessStockLockAdd: 'Create Inventory Reservation Order',
        BusinessStockLockView: 'Reservation Lock Order Details',
        BusinessStockVerifyLogicIndex: 'Logical Warehouse Allocation Review',
        BusinessStockVerifyLogicView: 'Logical Warehouse Allocation Review Details',
        BusinessStockVerifyVirtualView: 'Virtual Warehouse Transfer Review Details',
        BusinessStockVerifyLockView: 'Inventory Reservation Review Details',
        BusinessStockVerifyPlanView: 'Warehouse Division Plan Reviewt Details',
        BusinessStockDistributionRatioAddSku: 'Product Allocation - Bin Proportion Allocation',
        BusinessStockDistributionRatioAddWarehouse: 'Batch Allocation - Bin Proportion Allocation',
        BusinessStockDistributionRatioEdit: 'Edit Bin Proportion Allocation',
        BusinessStockDistributionRatioView: 'View Bin Proportion Allocation',
        BusinessStockDistributionPlanAdd: 'Create Warehouse Splitting Plan',
        BusinessStockDistributionPlanEdit: 'Edit Warehouse Splitting Plan',
        BusinessStockDistributionPlanView: 'View Warehouse Splitting Plan',
        BusinessStockSynchronizationAdd: 'Create Data Synchronization',
        BusinessThirdAfterAdd: 'Create External After-Sales Order',
        BusinessUserRoleAllotData: 'Assign Data Permissions',
        BusinessUserRoleAllotDataCSG: 'Assign Data Permissions',
        SettingWorkflowBpmnView: 'View Workflow',
        SettingFinanceStatementBaseIndex: 'Reconciliation Basic Configuration',

        BusinessMarketingActivityAdd: 'Add Gift Activity',
        BusinessMarketingActivityEdit: 'Edit Gift Activity',
        BusinessMarketingActivityView: 'View Gift Activity',
        BusinessMarketingGiftAdd: 'Add Associated Product Rule',
        BusinessMarketingGiftEdit: 'Edit Associated Product Rule',
        BusinessMarketingGiftView: 'View Associated Product Rule',
        BusinessO2OInternalView: 'Internal O2O Order Details',
        BusinessO2OInternalAdd: 'O2O Order Entry',
        BusinessThirdOrderAdd: 'External Order Entry',
        BusinessThirdO2OView: 'External O2O Order Details',
        BusinessWorksheetServiceIndex: 'Service',
        BusinessWorksheetServiceView: 'Service Details',
        SettingIndexesConfigListIndex: 'Index Configuration List',
        SettingIndexesConfigListAdd: 'Create Index',
        SettingIndexesConfigListEdit: 'Edit index',
        SettingInquiryIndex: 'Search Configuration',
        SettingInquiryAdd: 'Add Search Configuration',
        SettingInquiryEdit: 'Edit Search Configuration',
        SettingIndexesSyncIndex: 'Index Synchronization',
        SettingIndexesSyncAdd: 'Add Synchronized Index',
        SettingIndexesSyncEdit: 'Edit Synchronized Index',
        CommonPersonal: 'Account Center',
        dingHours: 'Ding 工时管理',
        CommonMenu: 'Menu Configuration',
        SettingBarcodeConfig: 'Barcode Configuration',
        BusinessAbnormalOrderUrgent_unurgent: 'Unurgent',
        BusinessWorkorder: 'Ticket',
        BusinessWorkorderType: 'Ticket Type',
        BusinessWorkorderList: 'Ticket List',
        BusinessOpenWorkorderList: 'Open Ticket',
        BusinessCloseWorkorderList: 'Closed Ticket',
        BusinessWorkorderListForm: 'Ticket',
        BusinessTools: 'Tools',
        BusinessrateCalculator: 'Freight Calculator',
        BusinessFreightCalculationDetails: 'Freight Calculator Details',
        BusinessSendEmail: 'Group Email',
        BusinessProfitCalculator: 'Profit Calculator',
    },
};
